import React from 'react';
import { isNil } from 'lodash';
import { Modal, message, Radio } from 'antd';
import { Form } from '@ant-design/compatible';
import { WrappedFormUtils } from '@ant-design/compatible/lib/form/Form';

interface SubmitWithExternalChannelModalResult {
  sendProductDataToSabangnet: boolean;
}

interface SubmitWithExternalChannelModalProps {
  form: WrappedFormUtils;
  title: string;
  description?: string;
  isOpen: boolean;
  closeModal: () => void;
  onOk: (result: SubmitWithExternalChannelModalResult) => void;
  onCancel: () => void;
}

const SubmitWithExternalChannelModal = (props: SubmitWithExternalChannelModalProps): JSX.Element => {
  const { title, description, form, isOpen, onOk, onCancel } = props;

  return (
    <Modal
      title={title}
      visible={isOpen}
      onOk={() => {
        const sendSabangnet = form.getFieldValue('sabangnet');

        if (isNil(sendSabangnet)) {
          message.error('사방넷 송신 여부 선택 하세요');
          return;
        }

        onOk({
          sendProductDataToSabangnet: sendSabangnet,
        });
      }}
      okText="확인"
      onCancel={() => onCancel()}
      cancelText="아니오"
    >
      <div>
        <div>{description}</div>

        <div className="send-multi-channel">
          <Form.Item label="상품 정보 사방넷 송신 여부">
            {form.getFieldDecorator('sabangnet', {
              rules: [{ required: true, message: '사방넷 송신 여부 선택 하세요' }],
              initialValue: false,
            })(
              <Radio.Group>
                <Radio value={true}>송신</Radio>
                <Radio value={false}>미 송신</Radio>
              </Radio.Group>,
            )}
          </Form.Item>
        </div>
      </div>
    </Modal>
  );
};

export default Form.create()(SubmitWithExternalChannelModal);
